module.exports = __webpack_public_path__ + "vb2s-white-background.e18442b28beb39a68d2d1fa29eb42e2a.svg";